import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import Pagination from '../../model/pagination';
import QueryEncoder from '../queryEncoder';
import CustomerModel from '../../model/customer.model';
import {catchError, switchMap} from "rxjs/operators";
import SessionStore from "../../app/util/sessionStore";
import GenericCrudService from "../genericCrud.service";

@Injectable()
export default class CustomerService extends GenericCrudService<CustomerModel> {
  public constructor(protected http: HttpClient) {
    super(http);
  }

  getApiName() {
    return 'customers';
  }
}
